import React from "react";
import Search from "./Search";
import PollContestStatus from "./PollContestStatus";
import MessagesBox from "./MessagesBox";
import SendMessageInput from "./SendMesaageInput";
import PinnedMessage from "./PinnedMessage.jsx";
import ScheduledChatMessages from "./ScheduledChatMessages";

const Chat = () => {
    return (
        <div className="chat-box" >
            <Search />
            <PollContestStatus />
            <PinnedMessage />
            <ScheduledChatMessages />
            <MessagesBox />
            <SendMessageInput />
        </div>
    )
};

export default Chat;
